/**
 * Component to Add or Edit a single organization
 */
import * as React from 'react';
import { Card, message, Breadcrumb, Steps } from 'antd';
import { IcommonProps } from '../common/props';
import '../../css/OrganizationAddEdit.scss';
import Util from '../common/utils';
import service from '../../service/apolloclient.service';
import { MSGDISPLAYTIME } from '../common/constants';
import { VIEWSTATE } from '../common/constants';
import { staticProperties, STATICKEYS }  from '../common/staticProperties';
import strings from '../../eyeguide-localization/customer/string.customer.add';
import ContentOne from './ContentOne';
import ContentTwo from './ContentTwo';
import ContentThree from './ContentThree';

const EVENT = {
    ADDORG: '/customer/add/',
    EDITORG: '/customer/edit/'
};

const Step = Steps.Step;

/**
 * Property definition 
 */
interface IOrganizationProps extends IcommonProps {

    save: any;
    cancel: any;
    navigationFrom: any;
    match: any;
    location: any;
    notifyCustomerUpdate: any;
}

/**
 * State definition
 */
interface IOrganizationState {
    classesWithErr: string;
    classesWithoutErr: string;
    errorname:    boolean;
    errorCname:    boolean;
    errorCphone:    boolean;
    errorCemail:    boolean;
    organization: any;
    current:        number;
    customer:       any;
    account:        any;
}

export default class CustomerAdd extends React.Component<IOrganizationProps, IOrganizationState> {

    steps: any = [];

    constructor(props: IOrganizationProps) {
        super(props); 
        this.state = {
            classesWithErr : 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorname: false,
            errorCname: false,
            errorCemail: false,
            errorCphone: false,
            organization: [],
            current: 0,
            customer: [],
            account: []
        };
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.handlePrevClick = this.handlePrevClick.bind(this);
    }

    async componentDidMount() {
        Util.resetScroll();
        console.log('componentDidUpdate');
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.CUSTOMER);
        staticProperties.set(STATICKEYS.selectedRoster, '');
        if (this.props.location.pathname.startsWith(EVENT.EDITORG)) {
            await this.getOrganizationToEdit(this.props.match.params.orgid);
        }
    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
    }
    
    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }

    render() { 
        // if (this.props.organization === '') { // if organization is empty, call is from Add Organization
        //     this.resetControls();
        // }
        console.log('org', this.state.organization);
        this.steps = [{
            id: 0,
            title: 'Customer Details',
            content: this.getContentOne(),
          }, {
            id: 1,
            title: 'Account Details',
            content: this.getContentTwo(),
          }, {
            id: 2,
            title: 'Confirmation',
            content: this.getContentThree(),
        }];
        return (
            <div className="OrganizationAddEdit">

                <Card >
                    <Breadcrumb>
                        <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/customer">{strings.lsOrgsTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item>
                            {this.state.organization instanceof Array && 
                            this.state.organization.length === 0 ? strings.lsAddTxt : strings.lsEditTxt}
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <br/>
                    <h3>{this.state.organization instanceof Array && 
                        this.state.organization.length === 0 ? strings.lsAddOrgTxt : strings.lsEditOrgTxt } </h3>
                </Card>
                <Card bordered={false} style={{ margin: '24px 16px' }} >
                    <div className="contentDiv"> 
                    <div style={{width: '60%'}}>
                    <Steps current={this.state.current}>
                        {this.steps.map(item => <Step key={item.id} title={item.title} />)}
                    </Steps>
                    </div>
                    </div>
                    <div className="steps-content">{this.steps[this.state.current].content}</div>
                </Card>
            </div>
        );
    }

    getContentOne() {
        return(
            <ContentOne
                handleNextClick={this.handleNextClick}
                customer={this.state.customer}
            />
        );
    }

    private getContentTwo() {
        return (
            <ContentTwo
                handleNextClick={this.handleNextClick}
                handlePrevClick={this.handlePrevClick}
                account={this.state.account}
            />
        );
    }

    private getContentThree() {
        return (
            <ContentThree
                handleSaveClick={this.handleSaveClick}
                handlePrevClick={this.handlePrevClick}
                customer={this.state.customer}
                account={this.state.account}
            />
        );
    }
   
    private async getOrganizationToEdit(id: any) {
        let ser = new service();
        let org: any = await ser.getOrganization(id);
        console.log('getOrganizationresponse', org);
        this.setState({organization: org});
    }

    private handleNextClick(obj: any, contentNum: number) {
        Util.resetScroll();
        if (contentNum === 1 ) {
            console.log('1st content next clicked');
            this.setState({
                current: 1,
                customer: obj
            });
        } else if (contentNum === 2 ) {
            console.log('2nd content next clicked');
            this.setState({
                current: 2,
                account: obj
            });
        } 
    }

    private handlePrevClick(contentNum: number) {
        Util.resetScroll();
        if (contentNum === 1 ) {
            console.log('1st content next clicked');
            this.setState({
                current: 0,
            });
        } else if (contentNum === 2 ) {
            console.log('1st content next clicked');
            this.setState({
                current: 1,
            });
        } 
    }

    private async handleSaveClick() {
        
        let ser = new service();
        let resp = await ser.addCustomer(this.state.customer, this.state.account);
        console.log('add customer resp', resp);
        if (resp.status === 0) {
            message.success('Customer added successfully!', MSGDISPLAYTIME);
            this.props.notifyCustomerUpdate();
            history.back();
        }

    }

}



// WEBPACK FOOTER //
// ./src/components/customer/CustomerAdd.tsx